import UAParser from "ua-parser-js";
import semverCompare from "semver-compare";

type SemanticVersion = [number, number, number];

// default export を使わなければ回避できる
export const parser = new UAParser(); // テスト可能なようにExportしている

/**
 * スマートフォンかどうかを返す
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO: 引数を削除する。引数を指定する箇所がいくつか存在するため、そちらも対応する
export function isSmartphone(_: unknown): boolean {
  return isAndroid() || isIOS();
}

/**
 * iOSか
 */
export function isIOS(): boolean {
  return parser.getOS().name === "iOS";
}

export function isAndroid() {
  return parser.getOS().name === "Android";
}

export function isPC(): boolean {
  const isMobile = isIOS() || isAndroid();
  return !isMobile;
}

function normalizeOSVersion(version: string): string {
  const parse = (x: any) => parseInt(x, 10);
  const ver = version.split(".").map(parse);
  return ver.concat([0, 0, 0]).slice(0, 3).join(".");
}

export function compareOSVersion(
  version: SemanticVersion,
  overrideParser?: UAParser,
) {
  return semverCompare(
    normalizeOSVersion((overrideParser || parser).getOS().version || ""),
    version.join("."),
  );
}
